import { CoreInformationType } from '@context/stateModels';

export const isCrossOnboardingProcess = (processDefinitionKey: string | undefined): boolean => {
  return processDefinitionKey?.endsWith('_CROSS_ONBOARDING') ?? false;
};

export const getProductTypeHeader = (
  currentStep: string,
  coreInformation: CoreInformationType
): { [key: string]: string } => {
  const productType = currentStep == 'Firma contratto conto' ? 'CONTO' : coreInformation.flowOnboardingCode!;

  return { 'Product-Type': productType };
};
